'use strict';

/* @ngInject */
export default class ConfirmRestartModalController {
  constructor(private $uibModalInstance) {}

  cancel() {
    this.$uibModalInstance.close(false);
  };

  ok() {
    this.$uibModalInstance.close(true);
  };


}
